module.exports = __webpack_public_path__ + "static/assets/ddfd995a788810fe477713bcfdcda1be.png";